import { atom } from 'jotai';
import { ICanvasMenuSelectedStepId, ICanvasMenuStep } from '@Eikochain/components/organisms/MarketingEditor/types';

export const canvasMenuStepsAtom = atom<ICanvasMenuStep[]>([]);
export const canvasMenuSelectedStepIdAtom = atom<ICanvasMenuSelectedStepId | null>(null);
